module.exports = __webpack_public_path__ + "static/media/about-eg-1.984c58bd.jpg";